import { useQuery } from "@tanstack/react-query";

import { careplanQueryOptions } from "@/domains/careplan/factories/careplan-query-options";
import {
  areAllDraftItemsInactive,
  buildDraftCartItems,
} from "@/domains/careplan/factories/draft-cart-items";
import { useCartStore } from "@/stores";

export const useIsCareplanCartEmpty = () => {
  const { data: cart } = useQuery({
    ...careplanQueryOptions.cart,
  });
  const recommendedCartLines = useCartStore((state) => {
    return state.recommendedCartLines;
  });

  if (!cart || !recommendedCartLines) {
    return false;
  }

  return areAllDraftItemsInactive(
    buildDraftCartItems({
      cartItems: cart.items,
      subscriptionProducts: [],
      recommendedCartLines,
    }),
  );
};
